import { TestArtifact } from '../../enums/test-artifact.enum';

/**
 * A class to store new user request data. This class serves as the base class for other user new user request
 * classes.
 */
export class BaseNewUserRequest {
  /** Boolean indicating whether the object is a test artifact */
  public testArtifact?: boolean;

  /**
   * @param firstName - The user's first name
   * @param lastName - The user's last name
   * @param email - THe user's email address
   * @param password - The user's password
   * @param roles - THe user's roles
   * @param testArtifact - An enum indicating whether the new user request is a test artifact
   */
  constructor(
    public firstName: string,
    public lastName: string,
    public email: string,
    public password: string,
    public roles: string[],
    testArtifact?: TestArtifact
  ) {
    if (testArtifact === TestArtifact.true) {
      this.testArtifact = true;
    }
  }
}
